import { useState } from "react";
import config from "./config";

export const useSetState = (initialState = {}) => {
  const [state, set] = useState(initialState);
  const setState = patch => {
    set(prev => Object.assign({}, prev, patch instanceof Function ? patch(prev) : patch));
  };

  return [state, setState];
};
